import { render, staticRenderFns } from "./channelCodeEdit.vue?vue&type=template&id=897c9770&scoped=true"
import script from "./channelCodeEdit.vue?vue&type=script&lang=js"
export * from "./channelCodeEdit.vue?vue&type=script&lang=js"
import style0 from "./channelCodeEdit.vue?vue&type=style&index=0&id=897c9770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897c9770",
  null
  
)

export default component.exports